<template>
  <div>
    <div v-if="isReady">
      <HeaderPage />
      <router-view></router-view>
      <FooterPage />
    </div>
  </div>
</template>
<script>
//import '../../src/assets/css/bundle.css'
// import 'vue-material/dist/vue-material.css'
// import 'vue-material/dist/theme/default.css'
// import 'vue-toast-notification/dist/theme-sugar.css';
import HeaderPage from "../components/HeaderPage.vue";
import FooterPage from "../components/FooterPage.vue";
import { showErrorAlert } from "../helpers";
import Axios from "axios";
import AuthService from "../authService";

export default {
  name: "ContentPage",
  components: { HeaderPage, FooterPage },

  data() {
    return {
      isReady: false,
      auth: new AuthService(),
    };
  },

  async created() {
    try {
      await Promise.all([
        this.$store.dispatch("getOrganization"),
        this.$store.dispatch("getCharity"),
        this.$store.dispatch("getSettings"),
        this.$store.dispatch("getMembership"),
        this.$store.dispatch("getUserProfile"),
        this.$store.dispatch("getCategories"),
        this.$store.dispatch("getPromotions"),
        this.$store.dispatch("getCharityCustom"),
        this.$store.dispatch("getOrderOptions"),
        this.$store.dispatch("getShippingItems"),
        this.$store.dispatch("getOrderItems"),
        this.$store.dispatch("getShippingCustomOptions"),
        this.$store.dispatch("getLocalDeliveryPricing"),
        this.$store.dispatch("getData"),
        //TODO: get discounts
        this.$store.dispatch("getDiscounts"),
      ]);

      this.isReady = true;

      this.$router.push("/content/landing").catch((error) => {
        if (error.name != "NavigationDuplicated") {
          throw error;
        }
      });
      //window.addEventListener('beforeunload', (event) => {
      // Cancel the event as stated by the standard.
      // alert('where are u going?')
      // event.preventDefault();
      // Chrome requires returnValue to be set.
      // event.returnValue = '';
      //});
      this.$store.dispatch("setSmartLook");
      // console.log("all state -=-=-> ", this.$store.state);

      /**========================================================================
       *?             Check if the user is active
       *========================================================================**/

      const user = await this.auth.checkIfUser();

      const token = localStorage.getItem("token");
      const GUID = token || user.profile?.sub || "";

      setInterval(() => {
        const PathInfo = window.location.href;
        Axios.post("https://loginfo.happypurim.com/api/Process", {
          GUID,
          PathInfo,
        });
      }, 30000);

      /*============================ END OF SECTION ============================*/
    } catch (error) {
      console.error(error);
      showErrorAlert(true);
    }
  },
  computed: {},
  mounted() {},
};
</script>
